import {
  Typography,
  IconClose,
  ColorValues,
  Radio,
  Flex,
} from '@banhala/ui-kit';
import type { ISingleTreeChildGroup } from './SingleTreeFilter';
import { Pressable } from 'react-native';

interface SmallCategoryProps {
  categoryList: ISingleTreeChildGroup['entity']['possibleItems'][number]['childList'];
  headerText: string;
  handleClickItem: (value: string) => void;
  selectedQueryValue: string;
}

export const SmallCategory = ({
  categoryList,
  handleClickItem,
  headerText,
  selectedQueryValue,
}: SmallCategoryProps) => {
  return (
    <Flex padding={{ horizontal: 18 }}>
      <Flex.Row
        justifyContent="space-between"
        padding={{ vertical: 10, horizontal: 10 }}
        borderBottomWidth={1}
        borderColor="border_black_primary"
      >
        <Typography type="body2" color="content_primary">
          {headerText}
        </Typography>
        <Pressable onPress={() => handleClickItem('')}>
          <IconClose fill={ColorValues.gray70} width={12} height={12} />
        </Pressable>
      </Flex.Row>
      {categoryList.map(({ text, queryValue }) => {
        return (
          <Flex
          key={text}
            borderBottomWidth={1}
            borderColor="bg_secondary"
            padding={{ vertical: 18 }}
          >
            <Radio
              value={selectedQueryValue === queryValue}
              label={text}
              onPress={() => {
                handleClickItem(queryValue);
              }}
              dotColor="black"
            />
          </Flex>
        );
      })}
    </Flex>
  );
};
